// import {useState} from 'react'
import { formatDistanceToNow, parseISO } from 'date-fns';
import frLocale from 'date-fns/locale/fr';
import DOMPurify from 'isomorphic-dompurify';
import { Grid , Divider } from "@mui/material";
import parse from 'html-react-parser';
import { motion } from "framer-motion";
import Paper from '@mui/material/Paper';
import Icon from '@mui/material/Icon';
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDAvatar from "dashboard/components/MDAvatar";
import IconButton from "@mui/material/IconButton";
import {ProductdetailsConainer} from "dashboard/components/MDModal";
import Ratings from "components/Home/products/components/Ratings"

const MotionCardModal = motion(ProductdetailsConainer);
const MotionIconButton = motion(IconButton);
const MotionDescBox = motion(MDBox);

const ProductDetails = ({product, setSelectedProduct, show, toggleModal, loader, color}) => {
    // const [scroll,setScroll] = useState("visible");
    const backVariants = {
        initial: {
          opacity: 0,
          y: -20,
        },
        animate: { opacity: 1, y: 0 },
      };
      
    const cardVariants = {
        initial: {
            opacity: 0,
            y: 0,
        },
        animate: { opacity: 1, y: -120 },
     };

  return (
        <MotionCardModal show={show} toggleModal={toggleModal} onClick={()=>setSelectedProduct(null)}  title="Modify your image">    
            {product ? (<motion.div
              layoutId={`card-container--index-${product.id}`}
              // className="product-details"
              >
              <Paper
                  component="div"
                  sx={{ display: 'block',  borderRadius:4, width:{xs:400, md: 574, lg : 768, xl : 900},  overflow:"hidden", position:"relative"}}
                  elevation={6}
                >
                <MotionIconButton
                    onClick={()=>setSelectedProduct(null)}
                    initial="initial"
                    animate="animate"
                    exit="initial"
                    transition={{ delay: 0.2, duration: 0.5 }}
                    variants={backVariants}
                    sx={{position:"absolute",zIndex:1024, m:1, backgroundColor:"rgba(0, 0, 0, 0.47)"}}
                    color="white"
                    // onAnimationComplete={modalScroll}
                  >
                  <Icon>close_icon</Icon>
                </MotionIconButton>
                <MDBox component="div" sx={{maxHeight:500, position:"relative"}}>
                  <MDBox
                    component="img" 
                    sx={{width: '100%',  objectFit: 'cover', maxHeight:500, minHeight:"70vh"}}
                    src={`${process.env.REACT_APP_PUBLIC_URL}/img/product/${product.selectedImage}`}
                    />
                  <MDBox component="div" sx={{background:'linear-gradient(0deg,#181818,transparent 50%)', height:'100%', width:"100%", position:"absolute", bottom:0}} />
                </MDBox>
                <MotionDescBox
                  initial="initial"
                  animate="animate"
                  exit="initial"
                  transition={{ delay: 0.1, duration: 0.5 }}
                  variants={cardVariants}
                  className="infoCard"
                  sx={{px:{ xs:2, md:3, lg :4}, py :2}}
                > 
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                      <MDTypography display="block" color="white" variant="h3" textTransform="capitalize" textAlign="left" fontWeight="regular">
                        {product.productName}
                      </MDTypography>
                      <MDTypography
                        variant={"caption"}
                        fontWeight="regular"
                        lineHeight={1}
                        color={color === "transparent" || color === "light" ? "text" : "white"}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <Icon>schedule</Icon>&nbsp;
                        {formatDistanceToNow(parseISO(product.createdAt),{locale: frLocale})}
                      </MDTypography>
                      <MDTypography
                        variant="h4"
                        color={color === "transparent" || color === "light" ? "text" : color}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          ml: 0.375,

                          "& .material-icons-round": {
                            ml: -0.375,
                          },
                        }}
                      >
                        <Ratings rating={product.rating} />
                      </MDTypography>
                    </Grid>
                    <Grid item sx={{display:"flex"}} xs={12} md={4}>
                      <Divider sx={{mx: 2, ml :-2, opacity:1}}  orientation="vertical" />
                      <MDBox mt={1} mb={2}>
                        <MDTypography color="white" variant="body2" component="div" >
                        <MDTypography color="white" variant="h5" component="span" >Prix : </MDTypography>
                          {product.price?.sold !== 0 ? 
                            (<><span style={{textDecoration:"line-through"}}>{product.priceShow?.original}</span> - <MDTypography variant="h5" component="span" color={color}>{product.priceShow?.sold}</MDTypography></>)      
                          : product.priceShow?.original}
                        </MDTypography>
                        <MDTypography color="white" variant="body2" component="div" >
                          <MDTypography color="white" variant="h5" component="span" >Catégorie : </MDTypography>
                          <MDTypography variant="h5" component="span" color={color}>{product.category?.name || "Autres"}</MDTypography>
                        </MDTypography>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MotionDescBox>
                
                <MDBox
                  p={{xs:1,md:2,lg:3}}
                  > 
                  <MDTypography mb={2} variant="h4" >A propos : </MDTypography>
                  <MDTypography color="text" variant="body2">
                    {parse(DOMPurify.sanitize(product.description))}
                  </MDTypography>
                </MDBox>
              </Paper>

            </motion.div>) : (
                <MDAvatar display="flex" sx={{padding: 0,position: "absolute",zIndex: 9,top: "50%",left: "50%",transform: "translate3d(-24px, -20px, 0)"}}  
                    src={loader} alt="Avatar" variant="square" size="md" />
            )}
            
        </MotionCardModal>
  )
}

export default ProductDetails